"use strict"

import React from "react"

import { black_color, grey_color, getLabelTranslationFactor } from "./utils"
import { withFontSizeConfig } from "../../../config/FontSizeConfigProvider"

const YAxis = ({
  y,
  width,
  gridlines,
  label,
  axisTitleFontSize,
  tickFontSize,
  suppAxisTitleFontSize,
  suppTickFontSize,
  isSuppPlot,
  tickNum = null, // # of ticks to show on Axis
  flipped = false, // flipped = true for Y2 axis
  formatter = (x) => x.toString(),
}) => {
  const [min, max] = y.range()
  const yTicks = tickNum ? y.ticks(tickNum) : y.ticks()
  const [scaledFontSize, scaledTickSize, translate_factor] = getLabelTranslationFactor(
    isSuppPlot ? suppAxisTitleFontSize : axisTitleFontSize,
    isSuppPlot ? suppTickFontSize : tickFontSize,
    flipped ? 4.25 : 3.65,
  )

  return (
    <g>
      <line x1={0} y1={min} x2={0} y2={max} stroke={black_color} />
      <path d={`M-5,${max + 8} L0,${max} L5,${max + 8}`} stroke={black_color} fill="none" />
      <g transform={`translate(${flipped ? "" : "-"}${translate_factor}, ${(max + min) / 2})`}>
        <text
          fill={black_color}
          transform="rotate(-90)"
          textAnchor="middle"
          fontFamily="Arial"
          fontSize={scaledFontSize}
        >
          {label}
        </text>
      </g>
      {formatter &&
        yTicks.map((tickValue, idx) => (
          <g key={idx} transform={`translate(0, ${y(tickValue)})`}>
            <line x1={flipped ? 5 : -5} y1={0} x2={0} y2={0} stroke={black_color} />
            <text
              x={flipped ? 7 : -7}
              y={4}
              fontFamily="Arial"
              fontSize={scaledTickSize}
              fill={black_color}
              textAnchor={flipped ? "start" : "end"}
            >
              {formatter(tickValue)}
            </text>
          </g>
        ))}
      {/* Horizontal Gridlines */}
      {gridlines && (
        <>
          {/* Adding 0 to the array to sure we have a gridline across the top edge of the plot */}
          {[...yTicks, 0].map((tickValue, i) => (
            <g key={i} transform={`translate(0, ${y(tickValue)})`}>
              <line x1={flipped ? -width : 0} y1={0} x2={flipped ? 0 : width} y2={0} stroke={grey_color} />
            </g>
          ))}
        </>
      )}
      {/* End Horizontal Gridlines */}
    </g>
  )
}

export default withFontSizeConfig(YAxis)
